import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {NbDialogService, NbMenuService, NbSidebarService, NbThemeService} from '@nebular/theme';
import {OktaAuthService} from '@okta/okta-angular';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sales-header',
  templateUrl: './sales-header.component.html',
  styleUrls: ['./sales-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SalesHeaderComponent implements OnInit {

  constructor(
      private themeService: NbThemeService,
      private nbMenuService: NbMenuService,
      private sidebarService: NbSidebarService,
      private dialogService: NbDialogService,
      public oktaAuth: OktaAuthService,
      private router: Router
  ) {}

  ngOnInit(): void {}
  toggleSidebar() {
    this.sidebarService.toggle(true, "left");
    return false;
  }

}
